export function parseAiSummaryBullets(summary: string | null | undefined): string[] {
	if (!summary) return [];
	return summary
		.split(/(?:^|\n)\s*-\s*/)
		.map((item) => item.trim())
		.filter(Boolean);
}
